import type {
  TripDto,
  TripCreateDto,
  TripUpdateDto,
  TripRouteDto,
} from '@camper-diary/shared';
import { api } from './client';

export type Trip = TripDto;
export type TripRoute = TripRouteDto;

export function listTrips() {
  return api<Trip[]>('/trips');
}

export function getTrip(id: string) {
  return api<Trip>(`/trips/${encodeURIComponent(id)}`);
}

export function createTrip(input: TripCreateDto) {
  return api<Trip>('/trips', { method: 'POST', body: input });
}

export function updateTrip(id: string, input: TripUpdateDto) {
  return api<Trip>(`/trips/${encodeURIComponent(id)}`, { method: 'PATCH', body: input });
}

export function deleteTrip(id: string) {
  return api<null>(`/trips/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export function getTripRoute(id: string) {
  return api<TripRoute>(`/trips/${encodeURIComponent(id)}/route`);
}
